<template>
  <div class="distributor-user-index">
    <div class="user-header" v-if="user">
      <div class="info-wrapper">
        <div class="left"><img :src="user.avatar" class="user-avatar"></div>
        <div class="right">
          <span class="iconfont btn-exit" @click="logout">&#xe688;</span>
          <div><span class="user-name">{{user.real_name}}</span><span class="common-score-wrapper"><i class="iconfont front" :style="{width:user.score_percent+'%'}"></i><i class="iconfont back"></i></span></div>
          <div><span class="user-phone">{{user.phone}}</span></div>
        </div>
      </div>
      <div class="user-statis">
        <div class="item"><span class="strong">{{statistics?statistics.average_time:0}}</span><span class="info">{{ $t('distributor.general.unit_minute') }}（{{ $t('distributor.account.today_average_time') }}）</span></div>
        <div class="item"><span class="strong">{{statistics?statistics.total_count:0}}</span><span class="info">{{ $t('distributor.general.unit_order') }}（{{ $t('distributor.account.totay_total_orders') }}）</span></div>
      </div>
    </div>

    <div class="distributor-menu main-content">
		<div v-if="user.state==1 && user.store_id==0" @click="$router.push({name:'DistributorErrandOrderList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.deliver_orders') }}</span></flex-line></div>
		<div v-if="user.state==1" @click="$router.push({name:'DistributorOrderList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.history') }}</span></flex-line></div>
		<div @click="$router.push({name:'DistributorInformation'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.profile') }}</span></flex-line></div>
		<!-- <div v-if="user.state==2 || user.state==3" @click="$router.push({name:'DistributorAuthentication'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">认证信息</span></flex-line></div> -->
		<!-- <div @click="$router.push({name:'DistributorInformation'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">业绩统计</span></flex-line></div> -->
		<div v-if="user.state==1" @click="$router.push({name:'DistributorSettleList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.settle_list') }}</span></flex-line></div>
		<div @click="$router.push({name:'DistributorNoticeList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.messages') }}</span></flex-line></div>
		<!--<div @click="$router.push({name:'DistributorInformation'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">平台帮助</span></flex-line></div>-->
		<div @click="$router.push({name:'DistributorAccountSafe'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.account') }}</span></flex-line></div>
		<div v-if="user.state==1" @click="$router.push({name:'DistributorSystemSet'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.configuration') }}</span></flex-line></div>
      <!--<mt-cell class="menu-item"
               title="业绩统计"
               to="/distributor/record_statis"
               is-link>
        <span slot="icon" class="left-icon iconfont">&#xe617;</span>
      </mt-cell>-->

      <!--<mt-cell class="menu-item"
               title="平台帮助"
               to="/distributor/article_list"
               is-link>
        <span slot="icon" class="left-icon iconfont">&#xe614;</span>
      </mt-cell>-->
    </div>
  </div>
</template>

<script>
import { logout } from '../../../api/distributorLogout'
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { getUserInfo, getUserStatistics } from '../../../api/distributorUser'
import flexLine from '../../flexLine'
export default {
	components: {
	  flexLine
	},
  name: 'DistributorUser',
  data () {
    return {

    }
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'DistributorLogin' })
    } else {
      // if (this.user.invalid_time < parseInt((new Date().getTime()) / 1000)) { // 重新拉取信息
        getUserInfo().then(res => {
          this.distributorUpdate({ info: res.result.user })
        }).catch(function (error) {
          Toast(error.message)
        })
      // }
    }
    if (!this.statistics || this.statistics.invalid_time < parseInt((new Date().getTime()) / 1000)) {
      getUserStatistics().then(res => {
        this.distributorStatistics({ statistics: res.result.statistics })
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    ...mapMutations({
      distributorUpdate: 'distributorUpdate',
      distributorStatistics: 'distributorStatistics',
      distributorLogout: 'distributorLogout'
    }),
    logout () {
      logout().then(res => {
        this.distributorLogout()
        this.$router.push({ name: 'DistributorLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.distributor.info,
      statistics: state => state.distributor.statistics
    })
  }

}
</script>
<style  lang="scss" scoped>
	.main-content{padding: 0 $pageSpace;background: #fff;}
    .distributor-user-index{
    .user-header{background:#ff7007;color:#fff;font-size:.8rem;
      .info-wrapper{padding-top:1rem;padding-left:.5rem;padding-right:.5rem;display:flex;
        .left{width:2.5rem;
          .user-avatar{width:2rem;height:2rem;border-radius:2rem;}
        }
        .right{flex:1;line-height:1;
          .user-name{font-size:.8rem;line-height:1rem;}
          .common-score-wrapper{margin-left:.2rem}
          .user-phone{font-size:.6rem;opacity:.8;}
          .btn-exit{float:right;font-size:1rem;opacity: .8;}
        }
      }
      .user-statis{display:flex;font-size:.6rem;text-align:center;border-top:1px solid rgba(255,255,255,.2);margin-top:1rem;
        .item{flex:1;position:relative;padding:.5rem 0;
          .strong{font-size:1.5rem;}
          .info{opacity:.8;}
        }
        .item:after{content:'';display:block;width:1px;height:1.5rem;background:#fff;opacity:.2;position:absolute;right:0;top:50%;margin-top:-.75rem;}
        .item:last-child:after{display:none}
      }
    }
  }

</style>
